module.exports = __webpack_public_path__ + "static/media/rickmorty-demo.09847a8c.png";